module.exports = __webpack_public_path__ + "img/winter_snowball.9715f15c.png";